export const parseQueryString = (queryString) => {
  const qs = decodeURIComponent(queryString)
  const obj = {}
  const params = qs.split('&')
  params.forEach((param) => {
    const splitter = param.split('=')
    obj[splitter[0]] = splitter[1]
  })
  return obj
}

export const getURLParams = (search) => {
  const urlParams = new URLSearchParams(search)
  return parseQueryString(urlParams)
}
